[
  { "code": "AF", "name": { "en": "Afghanistan", "es": "Afganistán" } },
  { "code": "AX", "name": { "en": "Åland Islands", "es": "Islas Aland" } },
  { "code": "AL", "name": { "en": "Albania", "es": "Albania" } },
  { "code": "DZ", "name": { "en": "Algeria", "es": "Argelia" } },
  { "code": "AS", "name": { "en": "American Samoa", "es": "Samoa Americana" } },
  { "code": "AD", "name": { "en": "Andorra", "es": "Andorra" } },
  { "code": "AO", "name": { "en": "Angola", "es": "Angola" } },
  { "code": "AI", "name": { "en": "Anguilla", "es": "Anguila" } },
  { "code": "AQ", "name": { "en": "Antarctica", "es": "Antártida" } },
  { "code": "AG", "name": { "en": "Antigua and Barbuda", "es": "Antigua y Barbuda" } },
  { "code": "AR", "name": { "en": "Argentina", "es": "Argentina" } },
  { "code": "AM", "name": { "en": "Armenia", "es": "Armenia" } },
  { "code": "AW", "name": { "en": "Aruba", "es": "Aruba" } },
  { "code": "AU", "name": { "en": "Australia", "es": "Australia" } },
  { "code": "AT", "name": { "en": "Austria", "es": "Austria" } },
  { "code": "AZ", "name": { "en": "Azerbaijan", "es": "Azerbaiyán" } },
  { "code": "BS", "name": { "en": "Bahamas", "es": "Bahamas" } },
  { "code": "BH", "name": { "en": "Bahrain", "es": "Baréin" } },
  { "code": "BD", "name": { "en": "Bangladesh", "es": "Bangladés" } },
  { "code": "BB", "name": { "en": "Barbados", "es": "Barbados" } },
  { "code": "BY", "name": { "en": "Belarus", "es": "Bielorrusia" } },
  { "code": "BE", "name": { "en": "Belgium", "es": "Bélgica" } },
  { "code": "BZ", "name": { "en": "Belize", "es": "Belice" } },
  { "code": "BJ", "name": { "en": "Benin", "es": "Benín" } },
  { "code": "BM", "name": { "en": "Bermuda", "es": "Bermudas" } },
  { "code": "BT", "name": { "en": "Bhutan", "es": "Bután" } },
  { "code": "BO", "name": { "en": "Bolivia, Plurinational State of", "es": "Estado Plurinacional de Bolivia" } },
  { "code": "BQ", "name": { "en": "Bonaire, Sint Eustatius and Saba", "es": "Bonaire, San Eustaquio y Saba" } },
  { "code": "BA", "name": { "en": "Bosnia and Herzegovina", "es": "Bosnia y Herzegovina" } },
  { "code": "BW", "name": { "en": "Botswana", "es": "Botsuana" } },
  { "code": "BV", "name": { "en": "Bouvet Island", "es": "Isla Bouvet" } },
  { "code": "BR", "name": { "en": "Brazil", "es": "Brasil" } },
  { "code": "IO", "name": { "en": "British Indian Ocean Territory", "es": "Territorio Británico del Océano Índico" } },
  { "code": "BN", "name": { "en": "Brunei Darussalam", "es": "Brunéi" } },
  { "code": "BG", "name": { "en": "Bulgaria", "es": "Bulgaria" } },
  { "code": "BF", "name": { "en": "Burkina Faso", "es": "Burkina Faso" } },
  { "code": "BI", "name": { "en": "Burundi", "es": "Burundi" } },
  { "code": "CV", "name": { "en": "Cabo Verde", "es": "Cabo Verde" } },
  { "code": "KH", "name": { "en": "Cambodia", "es": "Camboya" } },
  { "code": "CM", "name": { "en": "Cameroon", "es": "Camerún" } },
  { "code": "CA", "name": { "en": "Canada", "es": "Canadá" } },
  { "code": "KY", "name": { "en": "Cayman Islands", "es": "Islas Caimán" } },
  { "code": "CF", "name": { "en": "Central African Republic", "es": "República Centroafricana" } },
  { "code": "TD", "name": { "en": "Chad", "es": "Chad" } },
  { "code": "CL", "name": { "en": "Chile", "es": "Chile" } },
  { "code": "CN", "name": { "en": "China", "es": "China" } },
  { "code": "CX", "name": { "en": "Christmas Island", "es": "Isla de Navidad" } },
  { "code": "CC", "name": { "en": "Cocos (Keeling) Islands", "es": "Islas Cocos" } },
  { "code": "CO", "name": { "en": "Colombia", "es": "Colombia" } },
  { "code": "KM", "name": { "en": "Comoros", "es": "Comoras" } },
  { "code": "CG", "name": { "en": "Congo", "es": "Congo" } },
  { "code": "CD", "name": { "en": "Congo, Democratic Republic of the", "es": "Congo, República Democrática del" } },
  { "code": "CK", "name": { "en": "Cook Islands", "es": "Islas Cook" } },
  { "code": "CR", "name": { "en": "Costa Rica", "es": "Costa Rica" } },
  { "code": "CI", "name": { "en": "Côte d'Ivoire", "es": "Côte d’Ivoire" } },
  { "code": "HR", "name": { "en": "Croatia", "es": "Croacia" } },
  { "code": "CU", "name": { "en": "Cuba", "es": "Cuba" } },
  { "code": "CW", "name": { "en": "Curaçao", "es": "Curazao" } },
  { "code": "CY", "name": { "en": "Cyprus", "es": "Chipre" } },
  { "code": "CZ", "name": { "en": "Czechia", "es": "Chequia" } },
  { "code": "DK", "name": { "en": "Denmark", "es": "Dinamarca" } },
  { "code": "DJ", "name": { "en": "Djibouti", "es": "Yibuti" } },
  { "code": "DM", "name": { "en": "Dominica", "es": "Dominica" } },
  { "code": "DO", "name": { "en": "Dominican Republic", "es": "República Dominicana" } },
  { "code": "EC", "name": { "en": "Ecuador", "es": "Ecuador" } },
  { "code": "EG", "name": { "en": "Egypt", "es": "Egipto" } },
  { "code": "SV", "name": { "en": "El Salvador", "es": "El Salvador" } },
  { "code": "GQ", "name": { "en": "Equatorial Guinea", "es": "Guinea Ecuatorial" } },
  { "code": "ER", "name": { "en": "Eritrea", "es": "Eritrea" } },
  { "code": "EE", "name": { "en": "Estonia", "es": "Estonia" } },
  { "code": "SZ", "name": { "en": "Eswatini", "es": "Esuatini" } },
  { "code": "ET", "name": { "en": "Ethiopia", "es": "Etiopía" } },
  { "code": "FK", "name": { "en": "Falkland Islands (Malvinas)", "es": "Islas Malvinas" } },
  { "code": "FO", "name": { "en": "Faroe Islands", "es": "Islas Feroe" } },
  { "code": "FJ", "name": { "en": "Fiji", "es": "Fiyi" } },
  { "code": "FI", "name": { "en": "Finland", "es": "Finlandia" } },
  { "code": "FR", "name": { "en": "France", "es": "Francia" } },
  { "code": "GF", "name": { "en": "French Guiana", "es": "Guayana Francesa" } },
  { "code": "PF", "name": { "en": "French Polynesia", "es": "Polinesia Francesa" } },
  { "code": "TF", "name": { "en": "French Southern Territories", "es": "Territorios Australes Franceses" } },
  { "code": "GA", "name": { "en": "Gabon", "es": "Gabón" } },
  { "code": "GM", "name": { "en": "Gambia", "es": "Gambia" } },
  { "code": "GE", "name": { "en": "Georgia", "es": "Georgia" } },
  { "code": "DE", "name": { "en": "Germany", "es": "Alemania" } },
  { "code": "GH", "name": { "en": "Ghana", "es": "Ghana" } },
  { "code": "GI", "name": { "en": "Gibraltar", "es": "Gibraltar" } },
  { "code": "GR", "name": { "en": "Greece", "es": "Grecia" } },
  { "code": "GL", "name": { "en": "Greenland", "es": "Groenlandia" } },
  { "code": "GD", "name": { "en": "Grenada", "es": "Granada" } },
  { "code": "GP", "name": { "en": "Guadeloupe", "es": "Guadalupe" } },
  { "code": "GU", "name": { "en": "Guam", "es": "Guam" } },
  { "code": "GT", "name": { "en": "Guatemala", "es": "Guatemala" } },
  { "code": "GG", "name": { "en": "Guernsey", "es": "Guernesey" } },
  { "code": "GN", "name": { "en": "Guinea", "es": "Guinea" } },
  { "code": "GW", "name": { "en": "Guinea-Bissau", "es": "Guinea-Bisáu" } },
  { "code": "GY", "name": { "en": "Guyana", "es": "Guyana" } },
  { "code": "HT", "name": { "en": "Haiti", "es": "Haití" } },
  { "code": "HM", "name": { "en": "Heard Island and McDonald Islands", "es": "Islas Heard y McDonald" } },
  { "code": "VA", "name": { "en": "Holy See", "es": "Santa Sede" } },
  { "code": "HN", "name": { "en": "Honduras", "es": "Honduras" } },
  { "code": "HK", "name": { "en": "Hong Kong", "es": "RAE de Hong Kong (China)" } },
  { "code": "HU", "name": { "en": "Hungary", "es": "Hungría" } },
  { "code": "IS", "name": { "en": "Iceland", "es": "Islandia" } },
  { "code": "IN", "name": { "en": "India", "es": "India" } },
  { "code": "ID", "name": { "en": "Indonesia", "es": "Indonesia" } },
  { "code": "IR", "name": { "en": "Iran, Islamic Republic of", "es": "Irán (República Islámica de)" } },
  { "code": "IQ", "name": { "en": "Iraq", "es": "Irak" } },
  { "code": "IE", "name": { "en": "Ireland", "es": "Irlanda" } },
  { "code": "IM", "name": { "en": "Isle of Man", "es": "Isla de Man" } },
  { "code": "IL", "name": { "en": "Israel", "es": "Israel" } },
  { "code": "IT", "name": { "en": "Italy", "es": "Italia" } },
  { "code": "JM", "name": { "en": "Jamaica", "es": "Jamaica" } },
  { "code": "JP", "name": { "en": "Japan", "es": "Japón" } },
  { "code": "JE", "name": { "en": "Jersey", "es": "Jersey" } },
  { "code": "JO", "name": { "en": "Jordan", "es": "Jordania" } },
  { "code": "KZ", "name": { "en": "Kazakhstan", "es": "Kazajistán" } },
  { "code": "KE", "name": { "en": "Kenya", "es": "Kenia" } },
  { "code": "KI", "name": { "en": "Kiribati", "es": "Kiribati" } },
  {
    "code": "KP",
    "name": { "en": "Korea, Democratic People's Republic of", "es": "República Popular Democrática de Corea" }
  },
  { "code": "KR", "name": { "en": "Korea, Republic of", "es": "República de Corea" } },
  { "code": "KW", "name": { "en": "Kuwait", "es": "Kuwait" } },
  { "code": "KG", "name": { "en": "Kyrgyzstan", "es": "Kirguistán" } },
  { "code": "LA", "name": { "en": "Lao People's Democratic Republic", "es": "República Democrática Popular Lao" } },
  { "code": "LV", "name": { "en": "Latvia", "es": "Letonia" } },
  { "code": "LB", "name": { "en": "Lebanon", "es": "Líbano" } },
  { "code": "LS", "name": { "en": "Lesotho", "es": "Lesoto" } },
  { "code": "LR", "name": { "en": "Liberia", "es": "Liberia" } },
  { "code": "LY", "name": { "en": "Libya", "es": "Libia" } },
  { "code": "LI", "name": { "en": "Liechtenstein", "es": "Liechtenstein" } },
  { "code": "LT", "name": { "en": "Lithuania", "es": "Lituania" } },
  { "code": "LU", "name": { "en": "Luxembourg", "es": "Luxemburgo" } },
  { "code": "MO", "name": { "en": "Macao", "es": "RAE de Macao (China)" } },
  { "code": "MG", "name": { "en": "Madagascar", "es": "Madagascar" } },
  { "code": "MW", "name": { "en": "Malawi", "es": "Malaui" } },
  { "code": "MY", "name": { "en": "Malaysia", "es": "Malasia" } },
  { "code": "MV", "name": { "en": "Maldives", "es": "Maldivas" } },
  { "code": "ML", "name": { "en": "Mali", "es": "Mali" } },
  { "code": "MT", "name": { "en": "Malta", "es": "Malta" } },
  { "code": "MH", "name": { "en": "Marshall Islands", "es": "Islas Marshall" } },
  { "code": "MQ", "name": { "en": "Martinique", "es": "Martinica" } },
  { "code": "MR", "name": { "en": "Mauritania", "es": "Mauritania" } },
  { "code": "MU", "name": { "en": "Mauritius", "es": "Mauricio" } },
  { "code": "YT", "name": { "en": "Mayotte", "es": "Mayotte" } },
  { "code": "MX", "name": { "en": "Mexico", "es": "México" } },
  { "code": "FM", "name": { "en": "Micronesia, Federated States of", "es": "Micronesia (Estados Federados de)" } },
  { "code": "MD", "name": { "en": "Moldova, Republic of", "es": "Moldavia (República de)" } },
  { "code": "MC", "name": { "en": "Monaco", "es": "Mónaco" } },
  { "code": "MN", "name": { "en": "Mongolia", "es": "Mongolia" } },
  { "code": "ME", "name": { "en": "Montenegro", "es": "Montenegro" } },
  { "code": "MS", "name": { "en": "Montserrat", "es": "Montserrat" } },
  { "code": "MA", "name": { "en": "Morocco", "es": "Marruecos" } },
  { "code": "MZ", "name": { "en": "Mozambique", "es": "Mozambique" } },
  { "code": "MM", "name": { "en": "Myanmar", "es": "Myanmar (Birmania)" } },
  { "code": "NA", "name": { "en": "Namibia", "es": "Namibia" } },
  { "code": "NR", "name": { "en": "Nauru", "es": "Nauru" } },
  { "code": "NP", "name": { "en": "Nepal", "es": "Nepal" } },
  { "code": "NL", "name": { "en": "Netherlands, Kingdom of the", "es": "Países Bajos (Reino de los)" } },
  { "code": "NC", "name": { "en": "New Caledonia", "es": "Nueva Caledonia" } },
  { "code": "NZ", "name": { "en": "New Zealand", "es": "Nueva Zelanda" } },
  { "code": "NI", "name": { "en": "Nicaragua", "es": "Nicaragua" } },
  { "code": "NE", "name": { "en": "Niger", "es": "Níger" } },
  { "code": "NG", "name": { "en": "Nigeria", "es": "Nigeria" } },
  { "code": "NU", "name": { "en": "Niue", "es": "Niue" } },
  { "code": "NF", "name": { "en": "Norfolk Island", "es": "Isla Norfolk" } },
  { "code": "MK", "name": { "en": "North Macedonia", "es": "Macedonia del Norte" } },
  { "code": "MP", "name": { "en": "Northern Mariana Islands", "es": "Islas Marianas del Norte" } },
  { "code": "NO", "name": { "en": "Norway", "es": "Noruega" } },
  { "code": "OM", "name": { "en": "Oman", "es": "Omán" } },
  { "code": "PK", "name": { "en": "Pakistan", "es": "Pakistán" } },
  { "code": "PW", "name": { "en": "Palau", "es": "Palaos" } },
  { "code": "PS", "name": { "en": "Palestine, State of", "es": "Palestina, Estado de" } },
  { "code": "PA", "name": { "en": "Panama", "es": "Panamá" } },
  { "code": "PG", "name": { "en": "Papua New Guinea", "es": "Papúa Nueva Guinea" } },
  { "code": "PY", "name": { "en": "Paraguay", "es": "Paraguay" } },
  { "code": "PE", "name": { "en": "Peru", "es": "Perú" } },
  { "code": "PH", "name": { "en": "Philippines", "es": "Filipinas" } },
  { "code": "PN", "name": { "en": "Pitcairn", "es": "Islas Pitcairn" } },
  { "code": "PL", "name": { "en": "Poland", "es": "Polonia" } },
  { "code": "PT", "name": { "en": "Portugal", "es": "Portugal" } },
  { "code": "PR", "name": { "en": "Puerto Rico", "es": "Puerto Rico" } },
  { "code": "QA", "name": { "en": "Qatar", "es": "Catar" } },
  { "code": "RE", "name": { "en": "Réunion", "es": "Reunión" } },
  { "code": "RO", "name": { "en": "Romania", "es": "Rumanía" } },
  { "code": "RU", "name": { "en": "Russian Federation", "es": "Rusia" } },
  { "code": "RW", "name": { "en": "Rwanda", "es": "Ruanda" } },
  { "code": "BL", "name": { "en": "Saint Barthélemy", "es": "San Bartolomé" } },
  {
    "code": "SH",
    "name": { "en": "Saint Helena, Ascension and Tristan da Cunha", "es": "Santa Elena, Ascensión y Tristán de Acuña" }
  },
  { "code": "KN", "name": { "en": "Saint Kitts and Nevis", "es": "San Cristóbal y Nieves" } },
  { "code": "LC", "name": { "en": "Saint Lucia", "es": "Santa Lucía" } },
  { "code": "MF", "name": { "en": "Saint Martin (French part)", "es": "San Martín (parte francesa)" } },
  { "code": "PM", "name": { "en": "Saint Pierre and Miquelon", "es": "San Pedro y Miquelón" } },
  { "code": "VC", "name": { "en": "Saint Vincent and the Grenadines", "es": "San Vicente y las Granadinas" } },
  { "code": "WS", "name": { "en": "Samoa", "es": "Samoa" } },
  { "code": "SM", "name": { "en": "San Marino", "es": "San Marino" } },
  { "code": "ST", "name": { "en": "Sao Tome and Principe", "es": "Santo Tomé y Príncipe" } },
  { "code": "SA", "name": { "en": "Saudi Arabia", "es": "Arabia Saudí" } },
  { "code": "SN", "name": { "en": "Senegal", "es": "Senegal" } },
  { "code": "RS", "name": { "en": "Serbia", "es": "Serbia" } },
  { "code": "SC", "name": { "en": "Seychelles", "es": "Seychelles" } },
  { "code": "SL", "name": { "en": "Sierra Leone", "es": "Sierra Leona" } },
  { "code": "SG", "name": { "en": "Singapore", "es": "Singapur" } },
  { "code": "SX", "name": { "en": "Sint Maarten (Dutch part)", "es": "Sint Maarten (parte neerlandesa)" } },
  { "code": "SK", "name": { "en": "Slovakia", "es": "Eslovaquia" } },
  { "code": "SI", "name": { "en": "Slovenia", "es": "Eslovenia" } },
  { "code": "SB", "name": { "en": "Solomon Islands", "es": "Islas Salomón" } },
  { "code": "SO", "name": { "en": "Somalia", "es": "Somalia" } },
  { "code": "ZA", "name": { "en": "South Africa", "es": "Sudáfrica" } },
  {
    "code": "GS",
    "name": { "en": "South Georgia and the South Sandwich Islands", "es": "Islas Georgia del Sur y Sandwich del Sur" }
  },
  { "code": "SS", "name": { "en": "South Sudan", "es": "Sudán del Sur" } },
  { "code": "ES", "name": { "en": "Spain", "es": "España" } },
  { "code": "LK", "name": { "en": "Sri Lanka", "es": "Sri Lanka" } },
  { "code": "SD", "name": { "en": "Sudan", "es": "Sudán" } },
  { "code": "SR", "name": { "en": "Suriname", "es": "Surinam" } },
  { "code": "SJ", "name": { "en": "Svalbard and Jan Mayen", "es": "Svalbard y Jan Mayen" } },
  { "code": "SE", "name": { "en": "Sweden", "es": "Suecia" } },
  { "code": "CH", "name": { "en": "Switzerland", "es": "Suiza" } },
  { "code": "SY", "name": { "en": "Syrian Arab Republic", "es": "Siria" } },
  { "code": "TW", "name": { "en": "Taiwan, Province of China", "es": "Taiwán (Provincia de China)" } },
  { "code": "TJ", "name": { "en": "Tajikistan", "es": "Tayikistán" } },
  { "code": "TZ", "name": { "en": "Tanzania, United Republic of", "es": "Tanzania, República Unida de" } },
  { "code": "TH", "name": { "en": "Thailand", "es": "Tailandia" } },
  { "code": "TL", "name": { "en": "Timor-Leste", "es": "Timor-Leste" } },
  { "code": "TG", "name": { "en": "Togo", "es": "Togo" } },
  { "code": "TK", "name": { "en": "Tokelau", "es": "Tokelau" } },
  { "code": "TO", "name": { "en": "Tonga", "es": "Tonga" } },
  { "code": "TT", "name": { "en": "Trinidad and Tobago", "es": "Trinidad y Tobago" } },
  { "code": "TN", "name": { "en": "Tunisia", "es": "Túnez" } },
  { "code": "TR", "name": { "en": "Türkiye", "es": "Turquía" } },
  { "code": "TM", "name": { "en": "Turkmenistan", "es": "Turkmenistán" } },
  { "code": "TC", "name": { "en": "Turks and Caicos Islands", "es": "Islas Turcas y Caicos" } },
  { "code": "TV", "name": { "en": "Tuvalu", "es": "Tuvalu" } },
  { "code": "UG", "name": { "en": "Uganda", "es": "Uganda" } },
  { "code": "UA", "name": { "en": "Ukraine", "es": "Ucrania" } },
  { "code": "AE", "name": { "en": "United Arab Emirates", "es": "Emiratos Árabes Unidos" } },
  {
    "code": "GB",
    "name": {
      "en": "United Kingdom of Great Britain and Northern Ireland",
      "es": "Reino Unido de Gran Bretaña e Irlanda del Norte"
    }
  },
  { "code": "UM", "name": { "en": "United States Minor Outlying Islands", "es": "Islas menores alejadas de EE. UU." } },
  { "code": "US", "name": { "en": "United States of America", "es": "Estados Unidos de América" } },
  { "code": "UY", "name": { "en": "Uruguay", "es": "Uruguay" } },
  { "code": "UZ", "name": { "en": "Uzbekistan", "es": "Uzbekistán" } },
  { "code": "VU", "name": { "en": "Vanuatu", "es": "Vanuatu" } },
  { "code": "VE", "name": { "en": "Venezuela, Bolivarian Republic of", "es": "Venezuela (República Bolivariana de)" } },
  { "code": "VN", "name": { "en": "Viet Nam", "es": "Vietnam" } },
  { "code": "VG", "name": { "en": "Virgin Islands (British)", "es": "Islas Vírgenes Británicas" } },
  { "code": "VI", "name": { "en": "Virgin Islands (U.S.)", "es": "Islas Vírgenes de EE. UU." } },
  { "code": "WF", "name": { "en": "Wallis and Futuna", "es": "Wallis y Futuna" } },
  { "code": "EH", "name": { "en": "Western Sahara", "es": "Sáhara Occidental" } },
  { "code": "YE", "name": { "en": "Yemen", "es": "Yemen" } },
  { "code": "ZM", "name": { "en": "Zambia", "es": "Zambia" } },
  { "code": "ZW", "name": { "en": "Zimbabwe", "es": "Zimbabue" } }
]
